import { Box, Paper } from "@mui/material";
import {
  MapContainer,
  TileLayer,
  // Polygon,
  useMap,
  Marker,
  Popup,
  // useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import MapPopup from "./MapPopup";

function LocationMap(props) {
  const { data: property } = props;
  // console.log(1999, property);

  const mapCenter = [property.lat, property.lng];

  // // Helper to construct the Google Maps Directions URL
  // const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${property.lat},${property.lng}`;
  // // const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=25.5,85.1&destination=${property.lat},${property.lng}`;

  // const nearestTransport = property.nearbyTransport?.[0];

  // const bedrooms = `${
  //   property.bedrooms === "studio"
  //     ? "Studio"
  //     : property.bedrooms === "1"
  //     ? `${property.bedrooms} Bedroom`
  //     : `${property.bedrooms} Bedrooms`
  // }`;

  // const paymentFrequencyDisplay = {
  //   monthly: "Monthly",
  //   yearly: "Yearly",
  //   daily: "Daily",
  // };

  // const displayPaymentFrequency =
  //   paymentFrequencyDisplay[property.paymentFrequency];

  // const propertyTypeDisplay = {
  //   apartment: "Apartment",
  //   villa: "Villa",
  //   hotel: "Hotel",
  // };

  // const displayPropertyType = propertyTypeDisplay[property.propertyType];

  // const defaultPosition = [property.lat, property.long]; // Example: London
  // const mapCenter = [property.lat, property.lng]; // Example: London
  // const mapCenter = position || defaultPosition;

  // Custom icon for the marker, if desired
  const customIcon = new L.Icon({
    iconUrl:
      "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41], // Adjust anchor to the bottom of the marker
  });

  // Component to zoom the map when a search result is found
  // const ZoomToLocation = ({ position }) => {
  //   const map = useMap();

  //   if (position) {
  //     map.setView(position, 16); // Zoom level can be adjusted here
  //   }

  //   return null;
  // };

  return (
    <Paper
      elevation={0}
      sx={{ borderRadius: "8px", overflow: "hidden", border: "1px solid #eee" }}
    >
      {/* <Box paddingBottom={2}>
        <Typography variant="h5" component="h2">
          {property.location}, {property.city}, {property.country}
        </Typography>
        <Typography variant="subtitle1" component="p">
          {property.propertyType}
        </Typography>
      </Box> */}
      <Box>
        <MapContainer
          center={mapCenter}
          zoom={16}
          style={{
            height: "500px",
            width: "100%",
            borderRadius: "8px",
          }}
          // attributionControl={false}
        >
          {/* Tile layer for the map */}
          <TileLayer
            // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'

            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          {/* Marker for the position */}
          <Marker position={mapCenter} icon={customIcon}>
            <Popup minWidth={220}>
              <MapPopup property={property} />
            </Popup>
          </Marker>

          {/* Automatically zoom to the searched location */}
          {/* <ZoomToLocation position={mapCenter} /> */}
        </MapContainer>
      </Box>

      {/* <Box
        paddingTop={3}
        // sx={{ borderTop: "1px solid rgb(221, 221, 221)" }}
      >
        <Typography variant="subtitle1" component="p">
          {property.comments}
        </Typography>
      </Box> */}
    </Paper>
  );
}

export default LocationMap;
